import Smartphones from 'Documents/views/DocumentsView/containers/Smartphones'
import Tablets from 'Documents/views/DocumentsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const DocumentsView = getCurrentDeviceView(Smartphones, Tablets)

export default DocumentsView
